// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_automation_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WorkflowAutomationService } from "./workflow_automation_service_pb";

/**
 * @generated from rpc bffuser.v1.WorkflowAutomationService.GetWorkflowAutomationAvailability
 */
export const getWorkflowAutomationAvailability = WorkflowAutomationService.method.getWorkflowAutomationAvailability;
